import React from 'react';
import { Anchor } from 'lucide-react';
import Capt from '../../assets/Capt. Maharshi Deepak Joshi.jpeg';

export default function FounderProfile() {
  return (
    <div className="lg:col-span-7 space-y-8">
      <div className="bg-white p-8 md:p-10 border border-gray-200 rounded-sm shadow-sm">
        <div className="flex flex-col md:flex-row md:items-center gap-6 mb-8 border-b border-gray-100 pb-8">
          <div className="w-32 h-32 bg-[#1E4363]/10 rounded-full flex items-center justify-center shrink-0 border-4 border-white shadow-md">
            <img src={Capt} alt="Capt. Maharshi Deepak Joshi" className="w-full h-full object-cover rounded-full" />
          </div>
          
          <div>
            <h2 className="text-3xl font-bold text-[#1E4363] font-serif mb-2">Capt. Maharshi Deepak Joshi</h2>
            <p className="text-[#87412A] font-bold tracking-wider text-sm mb-2">
              FOUNDER & CEO
            </p>
            <p className="text-[#2C3539]/60 text-xs font-semibold tracking-widest uppercase">
              Master Mariner | MBA | MICS | AFNI | FNMIS | Bsc (Nautical Sci.)
            </p>
          </div>
        </div>

        <div className="space-y-6 text-[#2C3539]/80 leading-relaxed text-base">
          <p>
            At the helm of CMJ Global is Capt. Maharshi Deepak Joshi, a highly dynamic Master Mariner bringing over 23 years of comprehensive experience in the maritime industry. His expertise spans both rigorous sea-going command and high-level onshore commercial operations.
          </p>
          <p>
            Serving 9 years in command as Master on Various types of shipss, Capt. Joshi has successfully managed complex cargo operations, navigation, and crew logistics across global waters. His deep understanding of vessel operations is complemented by his proven track record in commercial shipping, where he has driven revenue, optimized vessel utilization, and expertly navigated Charter Party negotiations.
          </p>
          <p>
            A firm believer in continual improvement, Capt. Joshi holds multiple prestigious industry certifications, including being a certified Pre-RightShip Vetting Auditor and an ISM/ISPS/MLC Internal Auditor. This dual perspective—from the bridge of a ship to the operator's desk—ensures that CMJ Global delivers highly practical, risk-controlled, and commercially viable solutions to every client.
          </p>
        </div>
      </div>
    </div>
  );
}